var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "wkb-trait-association-scores" },
    [
      _c("h4", { staticClass: "wkb-trait-association-scores-title" }, [
        _vm._v("Association scores"),
      ]),
      _c("p", { staticClass: "wkb-trait-association-scores-lead" }, [
        _vm._v(" For connected genes and mechanisms on the graph. "),
      ]),
      _vm.loading
        ? _c("p", { staticClass: "wkb-inspector-note" }, [
            _c("span", {
              staticClass: "wkb-inspector-spinner",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Loading association scores… "),
          ])
        : _vm.error
        ? _c(
            "p",
            { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm.summary
        ? [
            _c(
              "p",
              {
                staticClass:
                  "wkb-inspector-note wkb-trait-association-scores-summary",
              },
              [
                _c("strong", [_vm._v("Genes scored:")]),
                _vm._v(" " + _vm._s(_vm.summary.geneRows.length) + ". "),
                _c("strong", [_vm._v("Mechanisms scored:")]),
                _vm._v(" " + _vm._s(_vm.summary.factorRows.length) + ". "),
              ]
            ),
            _c("WorkspaceEvidenceTable", {
              attrs: {
                title: "Trait × gene scores",
                rows: _vm.summary.geneRows,
                columns: _vm.geneTraitColumns,
                "pagination-label": "Trait gene score pages",
              },
            }),
            _c("WorkspaceEvidenceTable", {
              attrs: {
                title: "Trait × mechanism relevance",
                rows: _vm.summary.factorRows,
                columns: _vm.factorTraitColumns,
                "pagination-label": "Trait mechanism score pages",
              },
            }),
          ]
        : _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(
              " No association scores were returned for connected genes or mechanisms on this graph. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }